interface HeaderProps {
  currentStep: number;
}

export default function Header({ currentStep }: HeaderProps) {
  return (
    <header className="bg-[#232E3C] border-b border-[#2C3847] sticky top-0 z-50 shadow-lg">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-gradient-to-br from-pink-500 to-rose-500 rounded-full flex items-center justify-center shadow-lg">
              <i className="ri-heart-fill text-white text-2xl"></i>
            </div>
            <div>
              <h1 className="text-xl font-bold text-white">Моя Валентинка</h1>
              <p className="text-xs text-gray-400">Telegram Mini App</p>
            </div>
          </div>
          
          <div className="flex items-center gap-4">
            <div className="hidden sm:flex items-center gap-2 bg-[#17212b] px-4 py-2 rounded-full border border-[#2C3847]">
              <i className="ri-telegram-fill text-[#2AABEE] text-xl"></i>
              <span className="text-sm font-medium text-gray-300">Telegram</span>
            </div>
            
            {currentStep > 1 && (
              <div className="bg-[#17212b] px-4 py-2 rounded-full border border-[#2C3847]">
                <span className="text-sm font-medium text-gray-300">Шаг {currentStep}/4</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}